import { createLocalVideoTrack } from '../../room/track/create';
import { Checker } from './checker';

export class PublishVideoCheck extends Checker {
  get description(): string {
    return 'Can publish video';
  }

  async perform(): Promise<void> {
    const room = await this.connect();

    const track = await createLocalVideoTrack();
    room.localParticipant.publishTrack(track);
    // wait for a few seconds to publish
    await new Promise((resolve) => setTimeout(resolve, 5000));

    // verify RTC stats that it's publishing
    const stats = await track.sender?.getStats();
    track.stop();

    if (!stats) {
      throw new Error('Could not get RTCStats');
    }
    let numPackets = 0;
    let jitter: number = 0;
    let packetLost;
    let rtt: number = 0;
    let maxRTT: number = 0;
    let bitrate: number = 0;
    let maxBitrate: number = 0;
    stats.forEach((stat) => {
      if (stat.type === 'outbound-rtp' && (stat.kind === 'video' || (!stat.kind && stat.mediaType === 'video'))) {
        numPackets += stat.packetsSent;
      }
      if (stat.type === 'candidate-pair') {
        bitrate = (stat.bytesSent * 8) / (stat.timestamp - stat.lastPacketSentTimestamp);
        maxBitrate = stat.availableOutgoingBitrate;
      }
      if (stat.type === 'remote-inbound-rtp' && (stat.kind === 'video' || (!stat.kind && stat.mediaType === 'video'))) {
        jitter = stat.jitter;
        packetLost = stat.fractionLost * 100;
        rtt = (stat.totalRoundTripTime / stat.roundTripTimeMeasurements) * 1000;
        maxRTT = stat.totalRoundTripTime * 1000;
      }
    });
    if (numPackets === 0) {
      throw new Error('Could not determine packets are sent');
    }
    this.appendMessage(`published ${numPackets} video packets`);
    this.appendMessage(` ${jitter} `);
    this.appendMessage(`${packetLost} `);
    this.appendMessage(`{"avg":"${rtt}","max":"${maxRTT}"} `);
    this.appendMessage(`{"avg":"${bitrate}","max":"${maxBitrate}"} `);
  }
}
